
import { css } from 'lit';
export default css`
:host{
  --pc-caption-color:var(--neutral-medium-gray);

  display:block;
}

.caption{
  color:var(--pc-caption-color);
  font-size:var(--fs-caption-mobile);
  line-height:var(--lh-caption-mobile);
  font-family:var(--ff-body);
}

@media (min-width: 992px){
  .caption{
    font-size:var(--fs-caption);
    line-height:var(--lh-caption);
  }
}
`;